import React, { useState } from "react";
import { toast } from "sonner";
import { usePortalAuth, formatPortalError } from "../../lib/portal-auth-context";
import { PageHeader } from "./portal-ui";

export default function PortalProfile() {
  const { user, api, refreshMe } = usePortalAuth();
  const [form, setForm] = useState({
    full_name: user.full_name || "",
    company: user.company || "",
    phone: user.phone || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await api.put("/auth/profile", form);
      await refreshMe();
      toast.success("Perfil actualizado");
    } catch (err) {
      setError(formatPortalError(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="portal-profile-page">
      <PageHeader
        eyebrow="Perfil"
        title="Datos de mi cuenta"
        subtitle="Esta información la usamos para contactarte y personalizar tu experiencia."
      />

      <form
        onSubmit={submit}
        className="bg-white border border-slate-200 p-6 md:p-8 max-w-xl"
        style={{ borderRadius: 4 }}
        data-testid="portal-profile-form"
      >
        <div className="mb-4">
          <label className="block text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mb-2">
            Correo
          </label>
          <input
            type="email"
            value={user.email}
            disabled
            className="icor-input bg-slate-50 text-slate-500 cursor-not-allowed"
          />
        </div>

        {[
          { k: "full_name", label: "Nombre completo" },
          { k: "company", label: "Institución / Empresa" },
          { k: "phone", label: "Teléfono" },
        ].map((f) => (
          <div key={f.k} className="mb-4">
            <label className="block text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mb-2">
              {f.label}
            </label>
            <input
              type="text"
              value={form[f.k]}
              onChange={(e) => update(f.k, e.target.value)}
              className="icor-input"
              data-testid={`portal-profile-${f.k}`}
            />
          </div>
        ))}

        <div className="mt-2 mb-5 p-4 bg-slate-50 border-l-2 border-[var(--icor-blue)] text-sm text-slate-600">
          <div className="font-semibold text-[var(--icor-navy)] text-xs uppercase tracking-[0.18em] mb-1">
            Cliente vinculado
          </div>
          {user.linked_client_id ? (
            <span data-testid="portal-profile-linked">
              Tu cuenta está vinculada al cliente ICOR.
            </span>
          ) : (
            <span data-testid="portal-profile-unlinked">
              Tu cuenta aún no está vinculada a una empresa cliente. Un
              administrador la vinculará pronto.
            </span>
          )}
        </div>

        {error && (
          <div
            data-testid="portal-profile-error"
            className="mb-5 p-3 text-sm text-red-700 bg-red-50 border border-red-200"
            style={{ borderRadius: 4 }}
          >
            {error}
          </div>
        )}

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="btn-primary disabled:opacity-60"
            data-testid="portal-profile-save"
          >
            {saving ? "Guardando..." : "Guardar cambios"}
          </button>
        </div>
      </form>
    </div>
  );
}
